module.exports = __webpack_public_path__ + "img/colors.f3a8aee4.svg";